




























































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import Service from "@/services/AuditKeslingService";
import Store from "@/store/modules/AuditKeslingStore";

@Component
export default class AuditKeslingForm extends Vue {
  @Prop({ required: true }) sessionId!: number;

  session: any = null;
  saveTimer: any = null;

  signDialog = false;
  signing = false;
  signPassword = "";
  signingRole: "auditor" | "petugas_jaga" | "" = "";

  signForm: any = {
    auditor_nama: "",
    auditor_jabatan: "",
    petugas_jaga_nama: "",
    petugas_jaga_jabatan: ""
  };

  get isLocked(): boolean {
    return !!this.session && !!this.session.is_locked;
  }

  get items(): any[] {
    return (this.session && this.session.items) || [];
  }

  get signingRoleLabel(): string {
    return this.signingRole === "auditor" ? "Auditor" : "Petugas Jaga";
  }

  async mounted() {
    await this.loadSession();
  }

  async loadSession() {
    const res = await Service.find(this.sessionId);
    this.session = res.data.data;
    this.signForm = {
      auditor_nama: this.session.auditor_nama || "",
      auditor_jabatan: this.session.auditor_jabatan || "",
      petugas_jaga_nama: this.session.petugas_jaga_nama || "",
      petugas_jaga_jabatan: this.session.petugas_jaga_jabatan || ""
    };
    Store.SET_CURRENT(this.session);
  }

  setHasil(item: any, value: "Y" | "T", checked: boolean) {
    if (this.isLocked) return;
    item.hasil = checked ? value : null;
    this.saveDebounced();
  }

  saveDebounced() {
    if (this.isLocked) return;
    if (this.saveTimer) clearTimeout(this.saveTimer);
    this.saveTimer = setTimeout(() => this.saveItems(), 500);
  }

  async saveItems() {
    if (!this.session || this.isLocked) return;
    const payload = this.items.map((i: any) => ({
      urutan: i.urutan,
      hasil: i.hasil,
      keterangan: i.keterangan
    }));
    try {
      const res = await Service.updateItemsBulk(this.sessionId, payload);
      this.session = res.data.data;
    } catch (e) {
      // ErrorAlert handles
    }
  }

  async saveHeader() {
    if (!this.session || this.isLocked) return;
    try {
      const res = await Service.update(this.sessionId, {
        unit_id: this.session.unit_id,
        unit_nama: this.session.unit_nama,
        tanggal_audit: this.session.tanggal_audit,
        ...this.signForm
      });
      this.session = res.data.data;
    } catch (e) {
      // ErrorAlert handles
    }
  }

  openSignDialog(role: "auditor" | "petugas_jaga") {
    this.signingRole = role;
    this.signPassword = "";
    this.signDialog = true;
  }

  async confirmSign() {
    if (!this.signPassword || !this.signingRole) return;
    this.signing = true;
    try {
      // persist any unsaved name/jabatan first
      await this.saveHeader();
      const method = this.signingRole === "auditor"
        ? Service.submitAuditor
        : Service.acknowledgePetugasJaga;
      await method(this.sessionId, { password: this.signPassword });
      this.signDialog = false;
      await this.loadSession();
    } finally {
      this.signing = false;
    }
  }

  printPdf() {
    Service.printPdf(this.sessionId);
  }

  formatDate(s: string) {
    if (!s) return "-";
    return new Date(s).toLocaleDateString("id-ID");
  }

  formatDateTime(s: string) {
    if (!s) return "-";
    return new Date(s).toLocaleString("id-ID");
  }
}
